// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";

function make_props(positionOpt, zIndexOpt, anchorOpt, onCloseClick, ref, param) {
  var position = positionOpt !== undefined ? Caml_option.valFromOption(positionOpt) : undefined;
  var zIndex = zIndexOpt !== undefined ? Caml_option.valFromOption(zIndexOpt) : undefined;
  var anchor = anchorOpt !== undefined ? Caml_option.valFromOption(anchorOpt) : undefined;
  return {
          position: position,
          anchor: anchor,
          zIndex: zIndex,
          onCloseClick: onCloseClick,
          ref: ref
        };
}

export {
  make_props ,
  
}
/* No side effect */
